import { defineComponent as _defineComponent } from 'vue'
import { currency } from "@/helpers/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimplePrice',
  props: {
    freeLabel: { default: "" },
    label: null,
    loading: { type: Boolean, default: false },
    value: { default: null },
    withDetailsLink: { type: Boolean, default: false }
  },
  emits: ["click:details-link"],
  setup(__props: any) {





return { __sfc: true,currency }
}

})